<template>
  <b-card>
    <template>
      <b-card-text v-if="!cartItems.length">
        <h3 class="text-muted text-center">Please input some Product data to calculate</h3>
      </b-card-text>
      <b-modal size="lg" title="Non-Disclosure Agreement" v-model="show" hide-footer>
        <h5> Dengan ini saya menyetujui bahwa:</h5>
        <ol>
          <li>
            <h6>Seluruh Tarif dan Dokumen Internal yang terdapat di Product Catalog bersifat
            <b>rahasia</b>
            <i>(confidential)</i>,
            terbatas hanya untuk karyawan Telkom.</h6>
          </li>
          <li>
            <h6>Berkewajiban menjaga kerahasiaan informasi Product Catalog.</h6>
          </li>
          <li>
            <h6>
              Tidak menyalahgunakan informasi yang diperoleh sehingga menyebabkan
              gangguan, hingga kerugian bagi perusahaan.
            </h6>
          </li>
          <li>
            <h6>
              Bertanggung jawab apabila terjadi penggunaan yang tidak benar terhadap
              informasi tersebut.
            </h6>
          </li>
        </ol>
        <b-form-checkbox class="mt-2" v-model="isChecked">Saya menyetujui dan memahami <b>Non-Disclosure Agreement</b> di atas</b-form-checkbox>
        <div class="d-flex justify-content-center align-items-center">
          <b-button size="sm" variant="light" class="mt-3 mr-2 w-25">Cancel</b-button>
          <b-button size="sm" @click="authorizedExport(formatJson)" variant="primary" class="mt-3 w-25">Ok</b-button>
        </div>
      </b-modal>
      <div v-for="itemProd in products" :key="itemProd.INDEX" class="watermarked-table">
        <h1 v-if="itemProd.COUNT" class="mb-1">{{itemProd.NAME}}</h1>
        <div v-for="(type,indeks) in itemProd.TYPE" :key="indeks">
          <h4 v-if="type.count" class="mt-1 prod-type-text">{{type.name}}</h4>
          <b-table-simple v-if="type.count" :bordered="true" class="mb-3 table-container">
            <b-thead head-variant="light">
              <b-tr>
                <b-th class="text-left col-product">Product</b-th>
                <b-th class="text-center">Item Name</b-th>
                <b-th class="text-center">Tariff</b-th>
                <b-th class="text-center col-qty">Qty</b-th>
                <b-th class="text-center">Total</b-th>
              </b-tr>
            </b-thead>
            <b-tbody>
              <b-tr v-for="item in cartItems" :key="item.index">
                <b-td v-if="item.prod_id == itemProd.INDEX && item.type == type.name">
                  {{item.root}} - {{item.name}}
                </b-td>
                <b-td v-if="item.prod_id == itemProd.INDEX && item.type == type.name" class="text-center">
                  {{item.item_name}}
                </b-td>
                <b-td v-if="item.prod_id == itemProd.INDEX && item.type == type.name" class="text-left">
                  <nobr>Rp. {{ new Intl.NumberFormat('id-ID').format(item.price) }}</nobr> <nobr>/ {{item.type}}</nobr>
                </b-td>
                <b-td v-if="item.prod_id == itemProd.INDEX && item.type == type.name" class="text-center">
                  {{ new Intl.NumberFormat('id-ID').format(item.qty) }}
                </b-td>
                <b-td v-if="item.prod_id == itemProd.INDEX && item.type == type.name" class="text-left">
                  <nobr>Rp. {{new Intl.NumberFormat('id-ID').format(item.price * item.qty)}}</nobr>
                </b-td>
              </b-tr>
            </b-tbody>
            <b-tfoot v-if="itemProd.COUNT" foot-variant="light">
              <b-tr v-if="type.count" variant="light">
                <b-th colspan="4" class="text-capitalize text-right">
                  <h6 class="font-weight-bolder">Total</h6>
                </b-th>
                <b-th class="text-left">
                  <h6 class="text-capitalize font-weight-bolder">
                    <nobr>Rp. {{
                      new Intl.NumberFormat('id-ID').format(
                        type.price
                      )
                    }}</nobr>
                  </h6>
                </b-th>
              </b-tr>
              <b-tr v-if="indeks == itemProd.TYPE.length - 1" variant="light">
                <b-th colspan="4" class="text-capitalize text-right">
                  <h6 class="font-weight-bolder">Grand Total</h6>
                </b-th>
                <b-th class="text-left">
                  <h6 class="text-capitalize font-weight-bolder">
                    <nobr>Rp. {{ new Intl.NumberFormat('id-ID').format(itemProd.TOTAL) }}</nobr>
                  </h6>
                </b-th>
              </b-tr>
            </b-tfoot>
          </b-table-simple>
        </div>
      </div>
    </template>
    <b-row>
      <b-col cols="12" md="6">
        <b v-if="cartItems.length">
          <i>*This document is property of Telkom Indonesia, strictly confidential,
            and for internal purpose only.</i>
        </b>
      </b-col>
      <b-col cols="12" md="6">
        <div v-if="cartItems.length" class="d-flex justify-content-end">
          <b-button id="export" variant="outline-primary">
            <feather-icon icon="FileTextIcon" class="mr-50" />Export
          </b-button>
        </div>
      </b-col>
    </b-row>
    <b-popover
      target="export"
      placement="bottom"
      triggers="click"
    >
      <b-button
        v-ripple.400="'rgba(113, 102, 240, 0.15)'"
        variant="flat-secondary"
        class="d-flex"
        @click="exportToExcel(
        cartItems,
        ['Product', 'Item', 'Type', 'Quantity', 'Price', 'Total'],
        ['product', 'item', 'type', 'qty', 'price', 'total'],
        fName,
        formatJson
      )"
      >
        Excel
      </b-button>
      <b-button
        v-ripple.400="'rgba(113, 102, 240, 0.15)'"
        variant="flat-secondary"
        class="d-flex"
        style="width: 100%;"
        @click="pdf('pdf-export')"
      >
        PDF
      </b-button>
    </b-popover>
  </b-card>
</template>

<script>
import {
  VBPopover,
  BPopover,
  BCard,
  BTableSimple,
  BThead,
  BTfoot,
  BTbody,
  BTr,
  BTh,
  BTd,
  BButton,
  BCardText,
  BFormGroup, BFormCheckbox, BButtonGroup
} from 'bootstrap-vue'
import axios from '@/libs/axios'
import { mapState, mapGetters } from 'vuex'
import Ripple from 'vue-ripple-directive'
import { saveAs } from 'file-saver'

export default {
  components: {
    VBPopover,
    BPopover,
    BCard,
    BTableSimple,
    BThead,
    BTr,
    BTh,
    BTd,
    BTbody,
    BTfoot,
    BButton,
    BCardText,
    BFormGroup, BFormCheckbox, BButtonGroup
  },
  directives: {
    Ripple,
    'b-popover': VBPopover,
  },
  data() {
    return {
      fName: '',
      show:false,
      isChecked: null,
      typeExport: '',
      records : {},
      headers : {},
      fieldVal : {},
      filename : "",
    }
  },
  computed: {
    ...mapState('calculator', ['cartItems','products']),
    ...mapGetters('calculator', ['totalPriceItem']),
  },
  methods: {
    async authorizedExport(formatJson) {
      if(this.isChecked && this.typeExport == "pdf-export"){
        let name = this.$moment(new Date()).format('YYYYMMDD');
        if(this.products.length > 1){
          name = name+' Calculator Multi Produk '+ this.pluck(this.products,'NAME')
        }else{
          name = name+' Calculator '+this.products[0].NAME
        }
        this.fName = name

        let postObj = {
          carts : this.cartItems,
          products : this.products
        }
        return await axios.post('/tarif/pdf', {
          res: postObj
        }, {
          responseType: 'blob'
        })
        .then(res => {
            saveAs(res.data, name && name)
        })
        .catch(err => console.error(err))
        .finally(
          this.isChecked = false,
          this.show = false
        )
      }else if(this.isChecked && this.typeExport !== "pdf-export"){
        import('@/libs/Export2Excel').then(excel => {
          const list = this.records
          const filename = this.filename
          const data = formatJson(this.fieldVal, list)
          excel.export_json_to_excel({
            header: this.headers,
            data,
            filename,
            autoWidth: true,
            bookType: 'xlsx'
          })
        })
        this.isChecked = false
        this.show = false
      }else{
        this.$notifOnClick(
          'Forbidden!', 
          "Downloading this file is strictly prohibited. Unauthorized access or distribution of this content is against our policy and may result in serious consequences, including legal action. Please respect these restrictions and do not attempt to download or share this file without proper authorization", 
          'danger', 
          'AlertTriangleIcon',
          'danger',
          'OK',
          () => {})
        this.isChecked = false
        this.show = false
      }
    },
    async pdf(type) {
      this.show = true
      this.typeExport = type 
    },
    pluck(array, key) {
      return array.map(o => o[key]);
    },
    exportToExcel (records, headers, fieldVal, filename, formatJson) {
      this.records = records
      this.headers = headers
      this.fieldVal = fieldVal
      this.filename = filename
      // this.formatJson = formatJson
      this.show = true
      this.typeExport = 'excel-export'
      // let arr = [
      //   [
      //     'title' = 'Specific Content Connectivity',
      //   ],
      //   [
      //     'type' = 'Monthly',
      //   ],
      // ]
      // import('@/libs/Export2Excel').then(excel => {
      //     const list = records
      //     const data = formatJson(fieldVal, list)
      //     excel.export_json_to_excel({
      //       header: headers,
      //       data,
      //       filename,
      //       autoWidth: true,
      //       bookType: 'xlsx'
      //     })
      // })
    },
    formatJson (filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => {
        let data = null
        data = v[j]

        if (j === 'product') {
          data = v.root
        }

        if (j === 'type') {
          data = v.type
        }

        if (j === 'item') {
          data = v.name
        }
        
        if (j === 'qty') {
          data = v.qty
        }
        
        if (j === 'price') {
          data = v.price
        }
        
        if (j === 'total') {
          data = v.price * v.qty
        }

        return data
      }))
    }
  },
  mounted() {
    this.fName = this.$moment(new Date()).format('YYYYMMDD');
    if(this.products.length > 1){
      this.fName = this.fName+' Calculator Multi Produk '+ this.pluck(this.products,'NAME')
    }else{
      this.fName = this.fName+' Calculator '+this.products[0].NAME
    }
  }
}
</script>
<style>
.watermarked-table {
  position: relative;
  overflow: auto;
}

.watermarked-table::before {
  content: 'CONFIDENTIAL';
  position: absolute;
  top: 55%;
  left: 45%;
  transform: translate(-50%, -50%) rotate(-12deg);
  font-size: 6rem;
  color: rgba(0, 0, 0, 0.20);
  z-index: 1;
  pointer-events: none;
  white-space: nowrap;
}

.watermarked-table .b-table-simple {
  position: relative;
  z-index: 2;
}

.table-container {
  min-width: 800px;
}

.col-product {
  width: unset;
}

.col-qty {
  width: unset;
}

.modal-header {
  background-color: red !important;
}

.modal-title {
  color:white !important;
  font-weight: 600
}

/* Small devices (phones, 767px and below) */
@media (max-width: 767px) {
  .prod-type-text {
    font-size: 1.25rem;
  }
  .watermarked-table::before {
    left: 300px;
  }
}

/* Medium devices (tablets, 768px and up) */
@media (min-width: 768px) {
  .col-product {
    width: 400px;
  }
  .col-qty {
    width: 50px;
  }
}

/* Large devices (desktops, 992px and up) */
@media (min-width: 992px) {
  .col-product {
    width: 55vh;
  }
  .col-qty {
    width: 10vh;
  }
}
</style>
